import { Collection, ColorResolvable, Interaction, Message } from "discord.js";
import { AnyCommand, Bot, Emoji } from "..";
import { IPluginManager } from "../typings/plugins";
import { Plugin } from "../structures/plugins";

export default class PluginManager<Configs extends Record<string, any>, Emojis extends Record<string, Emoji>, Colors extends Record<string, ColorResolvable>> implements IPluginManager {
    public client: Bot<Configs, Emojis, Colors>;

    constructor(client: Bot<Configs, Emojis, Colors>) {
        this.client = client;
    }

    public store = new Collection<string, Plugin>();
    
    public events: IPluginManager["events"] = {
        prerun: {},
        postrun: {}
    };

    public commands: IPluginManager["commands"] = {
        precommand: [],
        postcommand: [],
        postprocess: [],
        postrun: []
    };

    register(plugin: Plugin) {
        this.store.set(plugin.name, plugin);

        if (
            (!(plugin.enabled ?? true)) ||
            (!(this.client.botOptions.enablePlugins ?? true) && plugin.enabled !== true)
        ) return;

        if (plugin.events) {
            for (const [name, options] of Object.entries(plugin.events)) {
                if (options.prerun) {
                    if (!this.events.prerun[name]) this.events.prerun[name] = [];
                    this.events.prerun[name].push(options.prerun);
                }
                if (options.postrun) {
                    if (!this.events.postrun[name]) this.events.postrun[name] = [];
                    this.events.prerun[name].push(options.postrun);
                }
            }
        }

        if (plugin.commands) {
            if (plugin.commands.precommand)
                this.commands.precommand.push(plugin.commands!.precommand)
            if (plugin.commands.postcommand)
                this.commands.postcommand.push(plugin.commands!.postcommand)
            if (plugin.commands.postprocess)
                this.commands.postprocess.push(plugin.commands!.postprocess!)
            if (plugin.commands.postrun)
                this.commands.postrun.push(plugin.commands!.postrun!)
        }
    }
}